import { Component, OnInit, ViewChild } from "@angular/core";
import { SharedModule } from "@shared/shared_module";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  ApiService,
  UserRole,
} from "@core/services/api/api.service";
import {
  AuditPermissionService,
  PermissionReference,
  userPermission,
} from "@core/services/audit-permission.service";
import { ToastMessageComponent } from "@shared/components/toast-message/toast-message.component";

export interface Checkbox {
  label: string;
  isSelected: boolean;
}

export interface Accordion {
  title: string;
  option: Checkbox[];
}

@Component({
  selector: "app-permissions",
  imports: [SharedModule, CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: "./permissions.component.html",
  styleUrl: "./permissions.component.scss",
})
export class PermissionsComponent implements OnInit {
  isOpen: number | null = null;
  checked: boolean = true;
  userRole: UserRole[] = [];
  permissionRole: userPermission[] = [];
  permissionReference: PermissionReference[] = [];
  permissionPop: boolean = false;
  permissionChange: {
    roleId: string | number;
    permission_id: string | number;
    has_permission: boolean;
  } | null = null;
  @ViewChild(ToastMessageComponent) toast!: ToastMessageComponent;
  constructor(
    private apiService: ApiService,
    private AuditPermissionService: AuditPermissionService
  ) {}
  ngOnInit(): void {
    this.getPermissionReference();
    this.getUserRole();
    this.getPermissionRole();
  }
  toggleAccordion(index: number) {
    this.isOpen = this.isOpen === index ? null : index;
  }
  getPermissionRole() {
    this.AuditPermissionService.getPermissionRole().subscribe({
      next: (res) => {
        this.permissionRole = res.roles;
      },
      error: (error) => {},
    });
  }
  getPermissionReference() {
    this.AuditPermissionService.getPermissionReference().subscribe({
      next: (response) => {
        this.permissionReference = response?.permissions;
      },
      error: (error) => {},
    });
  }
  getUserRole() {
    this.apiService.getUserRoles().subscribe({
      next: (response) => {
        this.userRole = response?.user_roles;
      },
      error: (err) => {},
    });
  }

  getUserNameById(id: string | number): string {
    const user = this.userRole.find((user) => user.id === id);
    return user ? user.name : "NA";
  }
  getUserDescriptionByID(id: string | number): string {
    const c = this.permissionReference.find((c) => c.id === id);
    return c ? c.description : "NA";
  }
  getPermissionName(id: string | number): string {
    const c = this.permissionReference.find((c) => c.id === id);
    return c ? c.name : "NA";
  }
  isRoleDisabled(roleId: string | number): boolean {
    const roleName = this.getUserNameById(roleId);
    return (
      roleName === "RA Admin" ||
      roleName === "Local RA (Bayer RA colleague)" ||
      roleName === "Local RA (Dealer & Distributor)"
    );
  }
  onPermissionChange(
    roleId: string | number,
    permission_id: string | number,
    has_permission: boolean
  ) {
    this.permissionChange = {
      roleId,
      permission_id,
      has_permission,
    };

    this.permissionPop = true;
  }
  onCancelPermission(event: any) {
    this.permissionPop = false;
    this.getPermissionRole();
  }
  onSubmitPermission(event: any) {
    this.permissionPop = false;
    this.updatePermission(
      this.permissionChange?.roleId!,
      this.permissionChange?.permission_id!,
      this.permissionChange?.has_permission!
    );
  }

  updatePermission(
    roleId: string | number,
    permission_id: string | number,
    has_permission: boolean
  ) {
    this.AuditPermissionService.updatePermission(
      roleId,
      permission_id,
      has_permission
    ).subscribe({
      next: (response) => {
        this.toast.showSuccess("success", response.message);
      },
      error: (error) => {
        this.toast.showError("error", error);
      },
    });
  }
}
